export type PositionId = number
export type WorkerRequirementId = number

export const verificationTypeEnum = [
  'age_limit',
  'assessment',
  'certificate',
  'drug_screening',
  'experience',
  'none',
  'photo_proof',
  'vehicle_information',
  'work_preference',
] as const

export type VerificationType = (typeof verificationTypeEnum)[number]

export const categoryEnum = [
  'General Requirements',
  'Attire & Grooming',
  'Certificates & Experience',
] as const

export type Category = (typeof categoryEnum)[number]
